exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-app-tsx": () => import("./../../../src/pages/app.tsx" /* webpackChunkName: "component---src-pages-app-tsx" */),
  "component---src-templates-landing-page-template-index-tsx": () => import("./../../../src/templates/landing-page-template/index.tsx" /* webpackChunkName: "component---src-templates-landing-page-template-index-tsx" */)
}

